<template>
  <div
    class="bg-white border border-gray-200 flex gap-4 p-2 rounded-lg align-middle min-w-[270px] h-full"
    :class="{
      'w-64 min-w-0 pl-8': !imageUrl,
      'py-4': !subtitle,
    }"
  >
    <div
      v-if="imageUrl"
      class="h-[80px] w-[80px] rounded-lg overflow-hidden aspect-square"
    >
      <NuxtLazyImg
        class="h-full w-full object-cover"
        draggable="false"
        :src="String(imageUrl)"
        :alt="`${imageAlt || title}`"
      />
    </div>
    <div class="flex-1 self-center">
      <div
        :class="
          twMerge(
            'text-left font-medium text-sm leading-5 line-clamp-3',
            titleClass
          )
        "
      >
        {{ title }}
      </div>
      <div v-if="subtitle" class="text-sm group-hover:text-primary">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    imageUrl?: string
    link: string
    imageAlt?: string
    titleClass?: string
  }>(),
  {
    title: '',
    subtitle: '',
    imageUrl: '',
    link: '',
    imageAlt: '',
    titleClass: '',
  }
)
const { title, subtitle, imageUrl, imageAlt } = props
</script>
